import { createReducer } from '../../../store.model';

import { DeleteMessages } from './state/delete-messages.action';
import { deleteMessagesReducer } from './state/delete-messages.reducer';
import { Load, LoadResult } from './state/load.action';
import { loadReducer, loadResultReducer } from './state/load.reducer';
import { ReceiveMessages } from './state/receive-messages.action';
import { receiveMessagesReducer } from './state/receive-messages.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { SendMessage } from './state/send-message.action';
import { sendMessageReducer } from './state/send-message.reducer';
import { UpdateChatResult } from './state/update-chat.action';
import { updateChatResultReducer } from './state/update-chat.reducer';
import { ActionType } from './teamschat-dialog.action';
import { defaultState, TeamschatDialogState } from './teamschat-dialog.state';

const { builder, reducer } = createReducer<ActionType, TeamschatDialogState>(
    defaultState(),
);

builder.add<Load>(ActionType.COACHING_DETAIL__TCD__LOAD, loadReducer);
builder.add<LoadResult>(
    ActionType.COACHING_DETAIL__TCD__LOAD_RESULT,
    loadResultReducer,
);

builder.add<Reload>(ActionType.COACHING_DETAIL__TCD__RELOAD, reloadReducer);
builder.add<ReloadResult>(
    ActionType.COACHING_DETAIL__TCD__RELOAD_RESULT,
    reloadResultReducer,
);

builder.add<ReceiveMessages>(
    ActionType.COACHING_DETAIL__TCD__RECEIVE_MESSAGES,
    receiveMessagesReducer,
);

builder.add<SendMessage>(
    ActionType.COACHING_DETAIL__TCD__SEND_MESSAGE,
    sendMessageReducer,
);

builder.add<DeleteMessages>(
    ActionType.COACHING_DETAIL__TCD__DELETE_MESSAGES,
    deleteMessagesReducer,
);

builder.add<UpdateChatResult>(
    ActionType.COACHING_DETAIL__TCD__UPDATE_CHAT_RESULT,
    updateChatResultReducer,
);

export const teamschatDialogReducer = reducer;
